import React from "react";
import { avatarAtomFamily } from "../jotai/atoms";
import { useAtom } from "jotai";
import { avatars } from "../utils/data";
import { Spinner } from "./spinner/Spinner";

export default function Avatar({ recordId, loading }: { recordId: string; loading?: boolean }) {
  const [avatarId] = useAtom(avatarAtomFamily(recordId));

  if (!avatarId || !avatars.get(avatarId)) {
    return (
      <div className="relative rounded-full">
        <img className={`${loading ? "opacity-20" : ""}`} src="/assets/images/user_white.png" />
        {loading && (
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 loading loading-spinner loading-xl text-neutral"></span>
        )}
      </div>
    );
  }

  return (
    <div className="relative rounded-full">
      <img className={`${loading ? "opacity-20" : ""}`} src={avatars.get(avatarId)} />
      {loading && (
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 loading loading-spinner loading-xl text-neutral"></span>
      )}
    </div>
  );
}
